import { Component, OnInit } from '@angular/core';
import { PluginServiceGlobalRegistrationAndOptions } from 'ng2-charts';

@Component({
  selector: 'app-distribution-by-queue',
  templateUrl: './distribution-by-queue.component.html',
  styleUrls: ['./distribution-by-queue.component.scss']
})
export class DistributionByQueueComponent implements OnInit {
  //Gráfico de barras
  public barChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true,
    legend: {
      display: true
    },
    scales: {
      xAxes: [{
        gridLines: {
          color: "rgba(0, 0, 0, 0)",
        }
      }],
      yAxes: [{
        gridLines: {
          color: "rgba(0, 0, 0, 0)",
        }
      }]
    }
  };
  public barChartLabels = ['Volume de atendimento de leads'];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartDatasets = [
    {
      data: [240],
      borderWidth: 1,
      backgroundColor: '#E1D8F0',
      borderColor: '#673BB6',
      hoverBackgroundColor: '#673BB6',
      hoverBorderColor: '#673BB6',
      label: 'Distribuídos',
      labels: ['Votes']
    },
    {
      data: [227],
      borderWidth: 1,
      backgroundColor: '#F8BBD0',
      borderColor: '#E81D62',
      hoverBackgroundColor: '#E81D62',
      hoverBorderColor: '#E81D62',
      label: 'Atendidos',
      labels: ['Votes']
    },
    {
      data: [13],
      borderWidth: 1,
      backgroundColor: '#BFE1DB',
      borderColor: '#00866E',
      hoverBackgroundColor: '#00866E',
      hoverBorderColor: '#00866E',
      label: 'Represados',
      labels: ['Votes']
    }
  ]

  //Gráfico circular
  public doughnutChartLabels = ['Leads'];
  public doughnutChartData = [
    {
      data: [48, 100 - 48],
      indexLabel: "#percent%",
      borderWidth: 1,
      backgroundColor: [
        "#B2F1F4",
        "#E5E5E5"
      ],
      borderColor: [
        '#20B5BB',
        '#DFE1E5'
      ],
      hoverBackgroundColor: [
        '#20B5BB',
        '#DFE1E5'
      ],
      hoverBorderColor: [
        "#B2F1F4",
        "#ffffff"
      ]
    }
  ];
  public doughnutChartType = 'doughnut';
  public doughnutChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true,
    hover: { mode: null },
    maintainAspectRatio: true,
    legend: { display: false },
    cutoutPercentage: 80,
    elements: {
      center: {
        text: '48%',
        color: '#36A2EB', //Default black
        fontStyle: 'Helvetica', //Default Arial
        sidePadding: 15 //Default 20 (as a percentage)
      }
    },
    tooltips: {
      callbacks: {
      },
    }
  }
  public doughnutChartPlugins: PluginServiceGlobalRegistrationAndOptions[] = [{
    beforeDraw: function (chart) {
      var width = chart.width,
        height = chart.height,
        ctx = chart.ctx;
      ctx.restore();
      var fontSize = (height / 114).toFixed(2);
      ctx.font = fontSize + "em sans-serif";
      ctx.textBaseline = "middle";
      var text = chart.config.options.elements['center'].text,
        textX = Math.round((width - ctx.measureText(text).width) / 2),
        textY = height / 2;
      ctx.fillText(text, textX, textY);
      ctx.save();
    }
  }];
  constructor() { }

  ngOnInit(): void {
  }

}
